import RestClient from './RestClient';
import Employee from '../models/Employee';
import KpiListResponse from '../models/KpiListResponse';
import CanEditResponse from '../models/CanEditResponse';
import CONFIG from '../config';

let Client = new RestClient({baseURL: CONFIG.API_URL});

export const EmployeeConfig = {
    DDS_ROOT_UUID: '2fda8739-3907-4f05-8c62-dd0876bc4a4a'
};

export const EmployeeApi = {
    getNonEmptyFilter(filter) {
        let parts = [];
        for (let key in filter) {
            if (key == 'ids' && filter[key].length > 0) {
                filter[key].forEach(id => {
                    parts.push('ids=' + id);
                });
            } else {
                if (filter[key].toString().length > 0) {
                    parts.push(key + '=' + filter[key].toString());
                }
            }
        }
        return parts.join('&');
    },

    async getList(filter) {
        try {
            const res = await Client.get('/api/v1/employee?' + this.getNonEmptyFilter(filter));
            if (res.data) {
                if (res.data.content && res.data.content.forEach) {
                    res.data.content.sort((left, right) => left.order - right.order);
                }
                return res.data;
            } else {
                console.log('res', res);
                return new KpiListResponse();
            }
        } catch (e) {
            console.log('error', e);
            return new KpiListResponse();
        }
    },

    async getByUuid(uuid) {
        try {
            let params = new URLSearchParams({
                ids: uuid,
                page: 0,
                size: 1
            });
            const res = await Client.get('/api/v1/employee?' + params.toString());
            if (res.data && res.data.content && res.data.content.length > 0) {
                return new Employee(res.data.content[0]);
            } else {
                console.log('res', res);
                return new Employee();
            }
        } catch (e) {
            console.log('error', e);
            return new Employee();
        }
    },

    async create(data) {
        try {
            const res = await Client.post('/api/v1/employee', data);
            return res;
        } catch (e) {
            console.log('error', e);
            return e;
        }

    },

    async update(data) {
        try {
            const res = await Client.put('/api/v1/employee/' + data.id, data);
            return res;
        } catch (e) {
            console.log('error', e);
            return e;
        }

    },

    async delete(id) {
        try {
            const res = await Client.delete('/api/v1/employee?id=' + id);
            return res;
        } catch (e) {
            console.log('error', e);
            return e;
        }

    },

    async mark(id, action) {
        try {
            const res = await Client.get('/api/v1/employee/' + id + '/mark?action=' + action);
            if (res.data) {
                return new CanEditResponse(res.data);
            } else {
                console.log('edit', id, res);
                return new CanEditResponse();
            }
        } catch (e) {
            console.log('error', e);
            return e;
        }
    }
};
